// repurposed from phoenix_html code in
// https://github.com/phoenixframework/phoenix_html/blob/master/priv/static/phoenix_html.js

type PhoenixAddEventListener = (
  type: 'phoenix.link.click', 
  handler: (e: MouseEvent) => boolean, 
  option: boolean
) => void

(() => {
  const prompt = (link: HTMLElement) => {
    const message = link.getAttribute('data-prompt-message');

    if (message) {
      // eslint-disable-next-line no-alert
      const response = window.prompt(message);
      const value = link.getAttribute('data-prompt-value');

      if (response === value) {
        return true;
      }
    }

    return false;
  };

  const handler = (e: MouseEvent) => {
    if (!e.target) { return false; }
    const element = e.target as HTMLElement;

    if (element.getAttribute('data-prompt-message')) {
      const confirmed = prompt(element);

      if (!confirmed) {
        e.preventDefault();
        e.stopImmediatePropagation();
        return false;
      }
    }

    return true;
  };

  (window.addEventListener as PhoenixAddEventListener)('phoenix.link.click', handler, false);
})();
